module.exports = __webpack_public_path__ + "f066a1a25d2184dbf69626a4c6cd1663.jpg";